// clipAPI.js - API service for clip management
import { fetchWithAuth } from "../apiutil";

export const clipAPI = {
  deleteClip: async (accessToken, clip) => {
    console.log(`[clipAPI.deleteClip] deleting clip: ${clip}`);
    return fetchWithAuth(
      `/api/cases/${clip.caseId}/clips/${clip.id}`,
      {
        method: "DELETE",
      },
      accessToken
    );
  },

  loadClip: async (accessToken, caseId, clipId) => {
    console.log(
      `[clipAPI.loadClip] loading clip: ${clipId} for case: ${caseId}`
    );
    return fetchWithAuth(
      `/api/cases/${caseId}/clips/${clipId}`,
      { method: "GET" },
      accessToken
    );
  },

  restoreClip: async (accessToken, clip) => {
    console.log(`[clipAPI.restoreClip] restoring clip: ${clip}`);
    return fetchWithAuth(
      `/api/cases/${clip.caseId}/clips/${clip.id}/restore`,
      {
        method: "POST",
      },
      accessToken
    );
  },

  revertClip: async (accessToken, caseId, clipId, commitId) => {
    console.log("[revertClip] revert clip", caseId, clipId, commitId);
    return fetchWithAuth(
      `/api/cases/${caseId}/clips/${clipId}/commits/${commitId}/revert`,
      {
        method: "POST",
      },
      accessToken
    );
  },

  trashClip: async (accessToken, clip) => {
    console.log(`[clipAPI.trashClip] trashing clip: ${clip}`);
    return fetchWithAuth(
      `/api/cases/${clip.caseId}/clips/${clip.id}/trash`,
      {
        method: "DELETE",
      },
      accessToken
    );
  },

  updateClipMetadata: async (accessToken, cur) => {
    console.log(`[clipAPI.updateClipMetadata] updating clip: ${cur}`);
    return fetchWithAuth(
      `/api/cases/${cur.caseId}/clips/${cur.id}`,
      {
        method: "PUT",
        body: JSON.stringify(cur),
      },
      accessToken
    );
  },
};
